import React from 'react';

import { Flex, Spin } from 'antd';
import classNames from 'classnames';

import styles from './Loader.module.scss';

type TLoaderProps = {
	size?: 'small' | 'default' | 'large';
	className?: string;
	absolute?: boolean;
};

export const Loader: React.FC<TLoaderProps> = ({
	size = 'default',
	className,
	absolute = false,
}) => {
	return (
		<Flex
			align="center"
			className={classNames(className, { [styles.absolute]: absolute })}
			justify="center"
		>
			<Spin size={size} />
		</Flex>
	);
};
